import { ManagementPeriodStatus } from "@leavy/lv-homesharing-srv/lib/hl/domain/HlManagementPeriod";
import { IsEnum, IsOptional } from "@leavy/validator";

export class HlUserManagementPeriodFiltersModel {
    @IsOptional()
    @IsEnum(ManagementPeriodStatus)
    status?: ManagementPeriodStatus;
}
